// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2SQN-","vLegacy":"SelectSecondary_vLegacy__2p0mG","error":"SelectSecondary_error__2mEmb","disabled":"SelectSecondary_disabled__15ey9"};